import React, { useState } from 'react'

export const OrderInfoContext = React.createContext()

export function OrderInfoContextProvider (props) {
  const [isOrderInfoEmpty, setIsOrderInfoEmpty] = useState(true) // 用来标记OrderInfo是否是因为刷新页面导致的为空。只要向缓存加过东西就置为false
  const [cacheAllFoodList, setCacheAllFoodList] = useState([]) // 缓存的全部的食物列表
  return (
    <OrderInfoContext.Provider
      value={{
        isOrderInfoEmpty: isOrderInfoEmpty,
        setIsOrderInfoEmpty: setIsOrderInfoEmpty,
        cacheAllFoodList: cacheAllFoodList,
        setCacheAllFoodList: setCacheAllFoodList
      }}
    >
      {props.children}
    </OrderInfoContext.Provider>
  )
}
